export default "__VITE_ASSET__CC24xODA__"